export class CallerConfigurationService {
    static $inject = ['MessagingHubService', 'MESSAGINGHUBDOMAIN'];
    constructor(MessagingHubService, MESSAGINGHUBDOMAIN) {
        this.MessagingHubService = MessagingHubService;
        this.MESSAGINGHUBDOMAIN = MESSAGINGHUBDOMAIN;
    }
    get(owner, useConfigurationsApplication = false) {
        const command = {
            method: 'get',
            uri: `lime://${owner}/configuration/caller`,
        };
        if (useConfigurationsApplication) {
            command.to = `postmaster@configurations.${this.MESSAGINGHUBDOMAIN}`;
        }
        return this.MessagingHubService.sendCommand(command);
    }
    getWithDomainOwner(owner, domainOwner, useConfigurationsApplication = false) {
        const command = {
            method: 'get',
            uri: `lime://${owner}/configuration/caller?owner=${domainOwner}`,
        };
        if (useConfigurationsApplication) {
            command.to = `postmaster@configurations.${this.MESSAGINGHUBDOMAIN}`;
        }
        return this.MessagingHubService.sendCommand(command);
    }
    getWithCaller(owner, caller, from, pp, useConfigurationsApplication = false) {
        const command = {
            method: 'get',
            uri: `lime://${owner}/configuration?caller=${caller}`,
            from,
            pp,
        };
        if (useConfigurationsApplication) {
            command.to = `postmaster@configurations.${this.MESSAGINGHUBDOMAIN}`;
        }
        return this.MessagingHubService.sendCommand(command);
    }
}
// Explicit AngularJS DI annotation for minification safety
// Order must match constructor parameter order
CallerConfigurationService.$inject = ['MessagingHubService', 'MESSAGINGHUBDOMAIN'];
